import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1MbmvGL2UdqYSxumRyWCCLLP': PlanNames.MultiPlus,
    'price_1MbmujL2UdqYSxumjW9SBV0F': PlanNames.Multi,
    'price_1MbmtuL2UdqYSxumTYj9V9jW': PlanNames.Professional,
    'price_1MbmrkL2UdqYSxumlLo0RMSV': PlanNames.Starter,
    'price_1MbmoEL2UdqYSxumtudFzTCs': PlanNames.Mini,
};
//# sourceMappingURL=july2023.js.map